webpackJsonp([240162396545425],{

/***/ 113:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Buttons = function Buttons(_ref) {
	  var sc = _ref.sc;
	  return _react2.default.createElement(
	    'ul',
	    null,
	    _react2.default.createElement(
	      'li',
	      null,
	      ' ',
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', onClick: function onClick(e) {
	            sc.gen('plug-in');
	          } },
	        ' Plug In '
	      ),
	      ' '
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      ' ',
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-secondary', onClick: function onClick(e) {
	            sc.gen('start');
	          } },
	        ' Start '
	      ),
	      ' '
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      ' ',
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-success', onClick: function onClick(e) {
	            sc.gen('stop');
	          } },
	        ' Stop '
	      ),
	      ' '
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      ' ',
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-info', onClick: function onClick(e) {
	            sc.gen('unplug');
	          } },
	        ' Unplug '
	      ),
	      ' '
	    )
	  );
	};
	
	exports.default = Buttons;
	module.exports = exports['default'];

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

	module.exports = "import React from 'react'\n\nconst Buttons = ({sc}) => (\n  <ul>\n    <li> <button className=\"btn btn-primary\" onClick={(e) => {sc.gen('plug-in')}}> Plug In </button> </li>\n    <li> <button className=\"btn btn-secondary\" onClick={(e) => {sc.gen('start')}}> Start </button> </li>\n    <li> <button className=\"btn btn-success\" onClick={(e) => {sc.gen('stop')}}> Stop </button> </li>\n    <li> <button className=\"btn btn-info\" onClick={(e) => {sc.gen('unplug')}}> Unplug </button> </li>\n  </ul>\n);\n\nexport default Buttons \n"

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cooking.8b8fbbf2.jpg";

/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/idle.2be550d6.jpg";

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _components = __webpack_require__(68);
	
	var _common = __webpack_require__(39);
	
	var _buttons = __webpack_require__(390);
	
	var _buttons2 = _interopRequireDefault(_buttons);
	
	var _buttons3 = __webpack_require__(888);
	
	var _buttons4 = _interopRequireDefault(_buttons3);
	
	var _microwaveDemo = __webpack_require__(392);
	
	var _microwaveDemo2 = _interopRequireDefault(_microwaveDemo);
	
	var _microwaveDemo3 = __webpack_require__(889);
	
	var _microwaveDemo4 = _interopRequireDefault(_microwaveDemo3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MicrowaveExample = function (_SCComponent) {
	  _inherits(MicrowaveExample, _SCComponent);
	
	  function MicrowaveExample(props) {
	    _classCallCheck(this, MicrowaveExample);
	
	    return _possibleConstructorReturn(this, _SCComponent.call(this, props, props.microwaveScxml));
	  }
	
	  MicrowaveExample.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'table',
	        { style: { width: '100%', height: '400px' } },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '200px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _buttons4.default,
	              component: _react2.default.createElement(_buttons2.default, { sc: this.sc }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                ' Buttons '
	              )
	            }),
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '400px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: this.props.microwaveScxml,
	              component: _react2.default.createElement(_schviz2.default, {
	                scxmlDocumentString: this.props.microwaveScxml,
	                disableAnimation: true,
	                configuration: this.state && this.state.configuration,
	                disableZoomAnimation: true,
	                transitionsEnabled: this.state && this.state.transitionsEnabled,
	                expandAllStatesByDefault: true,
	                id: 'microwave'
	              }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                'I am a ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'state machine'
	                )
	              ),
	              rowSpan: '2'
	            })
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '200px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _microwaveDemo4.default,
	              component: _react2.default.createElement(_microwaveDemo2.default, { configuration: this.state && this.state.configuration }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                ' Microwave '
	              )
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_components.ShowHideSourceCodeLink, { self: this })
	    );
	  };
	
	  return MicrowaveExample;
	}(_common.SCComponent);
	
	exports.default = MicrowaveExample;
	module.exports = exports['default'];

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cooking = __webpack_require__(1007);
	
	var _cooking2 = _interopRequireDefault(_cooking);
	
	var _idle = __webpack_require__(1008);
	
	var _idle2 = _interopRequireDefault(_idle);
	
	var _unplugged = __webpack_require__(1009);
	
	var _unplugged2 = _interopRequireDefault(_unplugged);
	
	__webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MicrowaveDemo = function MicrowaveDemo(_ref) {
	  var configuration = _ref.configuration;
	  return _react2.default.createElement('div', {
	    className: 'fill-image',
	    style: {
	      backgroundImage: 'url(' + function () {
	        switch (configuration && configuration[0]) {
	          case 'cooking':
	            return _cooking2.default;
	          case 'idle':
	            return _idle2.default;
	          case 'unplugged':
	            return _unplugged2.default;
	          default:
	            return '';
	        }
	      }() + ')'
	    } });
	};
	
	exports.default = MicrowaveDemo;
	module.exports = exports['default'];

/***/ }),

/***/ 889:
/***/ (function(module, exports) {

	module.exports = "import React from 'react'\nimport cooking from './cooking.jpg'\nimport idle from './idle.jpg'\nimport unplugged from './unplugged.jpg'\nimport '../common.css';\n\nconst MicrowaveDemo = ({configuration}) => (\n  <div \n    className=\"fill-image\"\n    style={{\n      backgroundImage:`url(${\n        (() => {\n          switch(configuration && configuration[0]){\n            case 'cooking': return cooking;\n            case 'idle': return idle;\n            case 'unplugged': return unplugged;\n            default: return '';\n          }\n        })()\n      })`\n    }}/>\n);\n\nexport default MicrowaveDemo; \n"

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

	module.exports = "<scxml>\n  <state id=\"unplugged\">\n    <transition event=\"plug-in\" target=\"plugged-in\"/>\n  </state>\n  <state id=\"plugged-in\">\n    <initial>\n      <transition target=\"idle\"/>\n    </initial>\n    <state id=\"cooking\">\n      <transition event=\"stop\" target=\"idle\"/>\n    </state>\n    <state id=\"idle\">\n      <transition event=\"start\" target=\"cooking\"/>\n    </state>\n    <transition event=\"unplug\" target=\"unplugged\"/>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

	module.exports = "<scxml>\n  <state id=\"unplugged\">\n    <transition event=\"plug-in\" target=\"plugged-in\"/>\n  </state>\n  <state id=\"plugged-in\" initial=\"idle\">\n    <state id=\"cooking\">\n      <transition event=\"stop\" target=\"idle\"/>\n    </state>\n    <state id=\"idle\">\n      <transition event=\"start\" target=\"cooking\"/>\n    </state>\n    <transition event=\"unplug\" target=\"unplugged\"/>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 892:
/***/ (function(module, exports) {

	module.exports = "<scxml>\n  <state id=\"unplugged\">\n    <transition event=\"plug-in\" target=\"plugged-in\"/>\n  </state>\n  <state id=\"plugged-in\">\n    <state id=\"idle\">\n      <transition event=\"start\" target=\"cooking\"/>\n    </state>\n    <state id=\"cooking\">\n      <transition event=\"stop\" target=\"idle\"/>\n    </state>\n    <transition event=\"unplug\" target=\"unplugged\"/>\n  </state>\n</scxml>\n\n"

/***/ }),

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/unplugged.f9e9b147.jpg";

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _microwaveExample = __webpack_require__(391);
	
	var _microwaveExample2 = _interopRequireDefault(_microwaveExample);
	
	var _microwave = __webpack_require__(890);
	
	var _microwave2 = _interopRequireDefault(_microwave);
	
	var _microwave3 = __webpack_require__(891);
	
	var _microwave4 = _interopRequireDefault(_microwave3);
	
	var _microwave5 = __webpack_require__(892);
	
	var _microwave6 = _interopRequireDefault(_microwave5);
	
	var _common = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Introduction = function Introduction(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    { className: 'container' },
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'You might have noticed in the introduction our example included ',
	      React.createElement(
	        'code',
	        null,
	        '<state>'
	      ),
	      ' nodes nested inside of other ',
	      React.createElement(
	        'code',
	        null,
	        '<state>'
	      ),
	      ' nodes. A ',
	      React.createElement(
	        'code',
	        null,
	        '<state>'
	      ),
	      ' node that has child states is known as a ',
	      React.createElement(
	        'strong',
	        null,
	        'compound state'
	      ),
	      '.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Compound states are immensely useful. They\u2019re a fantastic means of specifying that a group of states are themselves a state out of which a transition is possible. As in the vampire example: it doesn\u2019t matter if the character is intact, in smithereens, or even in torpor; if the character is burned then the character dies.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'The tricky bit is this: if the character were reconstituted from the ashes, what state would he be in? Intact? Torpor? If we were to add ',
	      React.createElement(
	        'code',
	        null,
	        '<transition event="reconstituted" target="alive"/>'
	      ),
	      ' inside the ',
	      React.createElement(
	        'code',
	        null,
	        'dead'
	      ),
	      ' state, it\u2019s not clear.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'There are two ways around this problem: always specify non-compound states (\u2018simple\u2019 states) as transition targets, or specify an ',
	      React.createElement(
	        'code',
	        null,
	        'initial'
	      ),
	      ' state for compound states. If you want your project to scale and you don\u2019t have a specific reason not to point to an initial state, we think you should do the latter.'
	    ),
	    React.createElement(
	      'h2',
	      null,
	      ' ',
	      React.createElement(
	        'code',
	        null,
	        '@initial'
	      ),
	      ', ',
	      React.createElement(
	        'code',
	        null,
	        '<initial>'
	      ),
	      ', or first child '
	    ),
	    React.createElement(
	      'p',
	      null,
	      'The SCXML standard is extremely consistent everywhere but here. Such is the way of a W3C standard, but that\u2019s part of W3C\u2019s strange beauty. You can specify the first sub-state to go to in a compound state in one of three ways: '
	    ),
	    React.createElement(
	      'ul',
	      null,
	      React.createElement(
	        'li',
	        null,
	        ' an ',
	        React.createElement(
	          'code',
	          null,
	          'initial'
	        ),
	        ' attribute on the compound state, or '
	      ),
	      React.createElement(
	        'li',
	        null,
	        ' an ',
	        React.createElement(
	          'code',
	          null,
	          '<initial>'
	        ),
	        ' node with a single ',
	        React.createElement(
	          'code',
	          null,
	          '<transition target="\u2026">'
	        ),
	        ' child, or '
	      ),
	      React.createElement(
	        'li',
	        null,
	        ' if neither an initial attribute nor ',
	        React.createElement(
	          'code',
	          null,
	          '<initial>'
	        ),
	        ' node are specified in the compound state, then the first child state will be the initial state '
	      )
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Here are three statecharts for a microwave that use compound states to describe how the microwave behaves when it\u2019s plugged in:'
	    ),
	    React.createElement(
	      'h6',
	      null,
	      ' ',
	      React.createElement(
	        'code',
	        null,
	        '@initial'
	      ),
	      ' '
	    ),
	    React.createElement(_common.ToggleableSchviz, { scxmlDocumentString: _microwave2.default, id: 'microwave1' }),
	    React.createElement(
	      'h6',
	      null,
	      ' ',
	      React.createElement(
	        'code',
	        null,
	        '<initial>'
	      ),
	      ' '
	    ),
	    React.createElement(_common.ToggleableSchviz, { scxmlDocumentString: _microwave4.default, id: 'microwave2' }),
	    React.createElement(
	      'h6',
	      null,
	      ' First child state '
	    ),
	    React.createElement(_common.ToggleableSchviz, { scxmlDocumentString: _microwave6.default, id: 'microwave3' }),
	    React.createElement(
	      'h6',
	      null,
	      ' Example '
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This example uses ',
	      React.createElement(
	        'code',
	        null,
	        '<initial>'
	      ),
	      ':'
	    ),
	    React.createElement(_microwaveExample2.default, { microwaveScxml: _microwave4.default }),
	    React.createElement(
	      'p',
	      null,
	      'Naturally you wouldn\u2019t want a microwave that\u2019s lost power to just keep cooking the moment it\u2019s plugged in again, so we\u2019ve specified ',
	      React.createElement(
	        'code',
	        null,
	        '"idle"'
	      ),
	      ' as the state to go to once it\u2019s plugged in.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'The ',
	      React.createElement(
	        'code',
	        null,
	        'initial'
	      ),
	      ' attribute occupies less space and is arguably more straightforward, especially since you\u2019re not actually allowed to do anything else with the ',
	      React.createElement(
	        'code',
	        null,
	        '<transition>'
	      ),
	      ' inside ',
	      React.createElement(
	        'code',
	        null,
	        '<initial>'
	      ),
	      ', but as long as you only use one of these two syntaxes you can decide for yourself which to use.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Using ',
	      React.createElement(
	        'code',
	        null,
	        'initial'
	      ),
	      ' or ',
	      React.createElement(
	        'code',
	        null,
	        '<initial>'
	      ),
	      ', you can specify compound interactions that have a default starting point. Later, we\u2019ll introduce a few other ways to jump to a state inside a compound state too, but now you have the tools you need to create a huge range of state machines.'
	    )
	  );
	};
	
	var WrappedIntroduction = function WrappedIntroduction(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: Introduction, pathname: location.pathname });
	};
	
	exports.default = WrappedIntroduction;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-compound-states-js-c9b4ca357974e9a81004.js